import Layout from "../components/layout";
import ProgressingDevelopment from "../components/progressing-development";

export default function Contact() {
  return (
    <Layout page="contact">
      <ProgressingDevelopment />
    </Layout>
  );
}